import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import AppSettings from 'src/app/common/app.settings';
import { EntityStatus, ItemStatus } from 'src/app/interfaces/views.interface';
import { AccountStatus } from 'src/app/swagger-api';
import { MaybeUndefined } from 'src/app/utils';

@Component({
  selector: 'app-small-profile-image',
  templateUrl: './small-profile-image.component.html',
  styleUrls: ['./small-profile-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmallProfileImageComponent {
  @Input({ required: true }) public accountStatus: EntityStatus;
  @Input({ required: true }) public dataTestId: string;
  @Input({ required: true }) public profileImage: MaybeUndefined<string>;

  @Input({ required: false }) public width = 64;
  @Input({ required: false }) public height = 64;
  @Input({ required: false }) public fontSize = '0.5rem';
  @Input({ required: false }) public class = 'user-avatar';
  @Input({ required: false }) public link = '';
  @Input({ required: false }) public accessForAdmin = false;
  @Input({ required: false }) public openInNewWindow = false;

  public readonly DEFAULT_PROFILE_IMAGE: string = AppSettings.NO_PHOTO_DEFAULT_IMAGE;
  public readonly DELETED_USER_IMAGE: string = AppSettings.DELETED_USER_IMAGE;

  public get image(): string {
    if (this.accountStatus === AccountStatus.DELETED) {
      return this.DELETED_USER_IMAGE;
    }

    if (this.isShowDeactivatedBadge || !this.profileImage) {
      return this.DEFAULT_PROFILE_IMAGE;
    }

    return this.profileImage;
  }

  public get isLinkActive(): boolean {
    return (
      this.accountStatus === AccountStatus.ACTIVE || this.accountStatus === ItemStatus.BLOCKED || this.accessForAdmin
    );
  }

  public get isShowDeactivatedBadge(): boolean {
    if (this.accessForAdmin && this.accountStatus === AccountStatus.DEACTIVATED) {
      return false;
    }

    return this.accountStatus === AccountStatus.DEACTIVATED;
  }
}
